// Private lesson notes. Local placeholder lessons fall back to localStorage.
import { supabase } from '../integrations/supabase/client';

function localKey(userId: string, lessonId: string) {
  return `lsem-note-${userId}-${lessonId}`;
}

export async function getLessonNote(userId: string, lessonId: string): Promise<string> {
  if (lessonId.startsWith('local-')) {
    try {
      return localStorage.getItem(localKey(userId, lessonId)) || '';
    } catch {
      return '';
    }
  }
  try {
    const { data } = await supabase.from('lesson_notes').select('content').eq('user_id', userId).eq('lesson_id', lessonId).maybeSingle();
    return (data as unknown as { content: string } | null)?.content ?? '';
  } catch {
    return '';
  }
}

export async function saveLessonNote(userId: string, lessonId: string, content: string): Promise<void> {
  if (lessonId.startsWith('local-')) {
    try {
      localStorage.setItem(localKey(userId, lessonId), content);
    } catch {
      /* ignore */
    }
    return;
  }
  const { error } = await supabase.from('lesson_notes').upsert(
    { user_id: userId, lesson_id: lessonId, content, updated_at: new Date().toISOString() },
    { onConflict: 'user_id,lesson_id' }
  );
  if (error) throw new Error(error.message);
}
